"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("@nerdwallet/marketplace/selectors/common");
var _default = function _default(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return {
    // Override with legacy ID for tracking continuity :(
    // @todo This is a product req that we should updated ASAP.
    productId: (0, _common.getLegacyId)(marketplaceEntity),
    text: 'Get Rate',
    vertical: 'Personal Loans'
  };
};
exports.default = _default;